<script>
    import { getContext } from 'svelte';
    import {DateTime} from "luxon";

    export let message;
    export let userId;
    export let onOkay = () => {};
    const { close } = getContext('simple-modal');

    let minDate = DateTime.now().minus({year: 1}).toFormat("yyyy-MM-dd")
    let maxDate = DateTime.now().toFormat("yyyy-MM-dd")
    let fromDate = '';
    let toDate = '';

    function _onOkay() {
        onOkay(fromDate, toDate, userId);
        close();
    }

    function fromDays(days) {
        fromDate = DateTime.now().minus({days: days}).toFormat("yyyy-MM-dd")
    }
</script>

<h4 class="text-center mb-3">{message}</h4>
<div class="buttons mb-3">
    <button on:click={()=>{fromDays(7)}} class="btn btn-sm btn-info">Останній тиждень</button>
    <button on:click={()=>{fromDays(1)}} class="btn btn-sm btn-info">За 1 день</button>
</div>
<div class="row mb-3">

    <label for="colFormLabel" class="col-sm-2 col-form-label text-black">Від дати</label>
    <div class="col-sm-10">
        <input type="date" class="form-control" id="colFormLabel" placeholder="col-form-label" min="{minDate}" max="{maxDate}" bind:value={fromDate}>
    </div>
    <label for="colToLabel" class="col-sm-2 col-form-label text-black">До дати</label>
    <div class="col-sm-10">
        <input type="date" class="form-control" id="colToLabel" placeholder="col-to-label" min="{minDate}" max="{maxDate}" bind:value={toDate}>
    </div>
</div>
<div class="buttons">
    <button on:click={_onOkay} class="btn btn-sm btn-success float-end">Експортувати <i class="bi bi-download"></i></button>
</div>